import { t } from '@lingui/core/macro';
import { formatRegistrationNumber } from 'noddi-util';

/** Invoice-payment banner copy, shared across invoice summaries so the text lives in one place. */
export const buildInvoiceText = (organizationName: string, registrationNumber?: string | null) => {
  const formattedRegistrationNumber = registrationNumber ? formatRegistrationNumber(registrationNumber) : null;

  return formattedRegistrationNumber
    ? t`This booking will be invoiced to ${organizationName} (${formattedRegistrationNumber}) after the service is completed.`
    : t`This booking will be invoiced to ${organizationName} after the service is completed.`;
};
